export default function usePathname(): string {
  return window.location.pathname;
}
